import type { FC } from 'react';
import { useLocation } from 'react-router';
import { useOptionalCapacityManagementRoot } from 'src/apis/capacity-management/use-capacity-management-root';
import { useOptionalDocumentExchangeRoot } from 'src/apis/document-exchange/use-document-exchange-root';
import { Link } from 'src/components/navigation/link';
import { Tabs } from 'src/components/navigation/tabs';

export const OperatorsTabs: FC = () => {
  const capacityManagementRoot = useOptionalCapacityManagementRoot();
  const documentExchange = useOptionalDocumentExchangeRoot();
  const { pathname } = useLocation();
  return (
    <Tabs className="print:hidden">
      <Link
        to="/operators/assignments"
        isActive={
          pathname.startsWith('/operators/assignments') ||
          pathname.startsWith('/dashboard/operators/assignments')
        }
      >
        Assignments
      </Link>

      {documentExchange.response?.data._links.getOperatorDocumentsInbox
        ?.href && <Link to="/operators/operator-documents">Documents</Link>}

      {!!capacityManagementRoot.response?.data._links?.myInvoicesV2 && (
        <Link to="/operators/invoices" data-testid="operators-invoices-tab">
          Invoices
        </Link>
      )}
    </Tabs>
  );
};
